import HorizontalLayout from '../../../components/HorizontalLayout';
import ThirdPartyQuestioner from '../pages/thirdparty/questioner';
import ThirdpartyHome from '../pages/thirdparty/home';
import Reports from '../pages/thirdparty/reports/list';
import Products from '../pages/thirdparty/products';
import ProductGeoCledianDetail from '../pages/thirdparty/products/geo-cledian-details';
import ProductDetailPage from '../pages/thirdparty/products/detail';
import ReportDetails from '../pages/thirdparty/reports/details/index';
import ReplaceContactPerson from '../pages/thirdparty/contact-person/index';
import BasicInformation from '../pages/thirdparty/basic-information';
import UserManual from '../pages/UserManual';
import EudrDueDiligence from '../pages/thirdparty/eudr-due-diligence';
import EudrDueDiligenceDeclare from '../pages/thirdparty/eudr-due-diligence/declare';
import EudrDueDiligenceAddGeoLocation from '../pages/thirdparty/eudr-due-diligence/add-geolocation';
import Communication from '../pages/thirdparty/communication';
import Documents from '../pages/thirdparty/documents';

import {
	ROUTE_PATH_THIRDPARTY_HOME,
	ROUTE_PATH_THIRDPARTY_FILL_QUESTIONNAIRE,
	ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
	ROUTE_PATH_THIRD_PARTY_REPORT_DETAILS,
	ROUTE_PATH_THIRD_PARTY_REPLACE_CONTACT_PERSON,
    ROUTE_PATH_THIRD_PARTY_BASIC_INFOS,
    ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE,
    ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE_DECLARE,
    ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE_ADD_GEO,
    ROUTE_PATH_THIRD_PARTY_PRODUCTS_LIST,
    ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
    ROUTE_PATH_THIRD_PARTY_COMMUNICATION,
    ROUTE_PATH_THIRD_PARTY_PRODUCT_GEO_DETAIL,
    ROUTE_PATH_THIRD_PARTY_PRODUCT_VIEW_DETAIL
} from '../constants';

const thirdPartyRoutes = [
	{
		path		: 	ROUTE_PATH_THIRDPARTY_HOME,
		component	: 	ThirdpartyHome,
		layout		: 	HorizontalLayout,
		type		: 	'third-party',
		modules		: 	['tp']
	},
	{
		path: '/third-party/3rd-party/user_manual',
		component: UserManual,
		layout: HorizontalLayout,
		type: 'third-party',
		modules: ["tp"]
	},
	{
		path		    : 	ROUTE_PATH_THIRDPARTY_FILL_QUESTIONNAIRE,
		component	    : 	ThirdPartyQuestioner,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE_DECLARE,
		component	    : 	EudrDueDiligenceDeclare,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE_ADD_GEO,
		component	    : 	EudrDueDiligenceAddGeoLocation,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRDPARTY_EUDR_DUE_DILIGENCE,
		component	    : 	EudrDueDiligence,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
	{
		path		    : 	ROUTE_PATH_THIRD_PARTY_REPORT_DETAILS,
		component	    : 	ReportDetails,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
	{
		path		    : 	ROUTE_PATH_THIRD_PARTY_REPORT_LIST,
		component	    : 	Reports,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_PRODUCT_GEO_DETAIL,
		component	    : 	ProductGeoCledianDetail,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_PRODUCT_VIEW_DETAIL,
		component	    : 	ProductDetailPage,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_PRODUCTS_LIST,
		component	    : 	Products,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_DOCUMENTS,
		component	    : 	Documents,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_BASIC_INFOS,
		component	    : 	BasicInformation,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
	{
		path		    : 	ROUTE_PATH_THIRD_PARTY_REPLACE_CONTACT_PERSON,
		component	    : 	ReplaceContactPerson,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	},
    {
		path		    : 	ROUTE_PATH_THIRD_PARTY_COMMUNICATION,
		component	    : 	Communication,
		layout		    : 	HorizontalLayout,
		type		    : 	'third-party',
		modules		    : 	['tp'],
        isAuthProtected :   true
	}
];

export default thirdPartyRoutes;

export {
	thirdPartyRoutes
};